import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49583734"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_inspection_waiting_approve_image",
  ref: "inspectionWaitingApproveImageModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-950px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_inspection_waiting_approve_image_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-400" }, null, -1))
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_inspection_waiting_approve_image_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_inspection_waiting_approve_image_header",
  "data-kt-scroll-wrappers": "#kt_modal_inspection_waiting_approve_image_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "upload-photos" }
const _hoisted_11 = { class: "fs-7 text-gray-400 mb-8" }
const _hoisted_12 = { class: "svg-icon svg-icon-5tx svg-icon-primary" }
const _hoisted_13 = { class: "el-upload__text" }
const _hoisted_14 = { class: "thumbnail-item" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "el-upload-list__item-actions" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "svg-icon svg-icon-1 svg-icon-white" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "svg-icon svg-icon-1 svg-icon-danger" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, null, -1))
const _hoisted_22 = { class: "fv-plugins-message-container invalid-feedback" }
const _hoisted_23 = { class: "modal-footer align-items-center justify-content-end" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1))
const _hoisted_26 = { class: "svg-icon svg-icon-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_FsLightbox = _resolveComponent("FsLightbox")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_5, [
                _createElementVNode("span", null, _toDisplayString(_ctx.t("inspection.inspection")) + " ", 1)
              ]),
              _hoisted_6
            ]),
            _createElementVNode("div", {
              "data-bs-dismiss": "modal",
              class: "btn btn-icon btn-sm btn-active-icon-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
            }, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createVNode(_component_el_form, {
            model: _ctx.formData,
            rules: _ctx.rules,
            "validate-on-rule-change": false,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.t("common.uploadDrone")), 1),
                    _withDirectives((_openBlock(), _createBlock(_component_el_upload, {
                      ref: "uploadRef",
                      class: _normalizeClass(["multiple-drag-upload bg-light-primary rounded border-primary border border-dashed", { hasfile: _ctx.fileList.length > 0 }]),
                      drag: "",
                      multiple: "",
                      "file-list": _ctx.fileList,
                      "auto-upload": false,
                      "show-file-list": true,
                      accept: ".jpg,.jpeg,.png",
                      headers: _ctx.uploadHeaders,
                      "on-change": _ctx.onUploadChange,
                      "on-error": _ctx.onUploadError
                    }, {
                      file: _withCtx(({ file }) => [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("img", {
                            class: "el-upload-list__item-thumbnail",
                            src: file.url,
                            alt: ""
                          }, null, 8, _hoisted_15),
                          _createElementVNode("span", _hoisted_16, [
                            _createElementVNode("span", {
                              class: "el-upload-list__item-preview",
                              onClick: ($event: any) => (_ctx.handlePreview(file))
                            }, [
                              _createElementVNode("span", _hoisted_18, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen004.svg" })
                              ])
                            ], 8, _hoisted_17),
                            (_ctx.itemData.is_stock === 0)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "el-upload-list__item-delete",
                                  onClick: ($event: any) => (_ctx.handleRemove(file))
                                }, [
                                  _createElementVNode("span", _hoisted_20, [
                                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr015.svg" })
                                  ])
                                ], 8, _hoisted_19))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      tip: _withCtx(() => [
                        _hoisted_21
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_12, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil022.svg" })
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createTextVNode(_toDisplayString(_ctx.t("common.uploadDrop")) + " ", 1),
                          _createElementVNode("em", null, _toDisplayString(_ctx.t("common.uploadClick")), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["class", "file-list", "headers", "on-change", "on-error"])), [
                      [_directive_loading, _ctx.uploadLoading]
                    ]),
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.uploadErrorMessage), 1)
                  ])
                ])
              ])), [
                [_directive_loading, _ctx.loading]
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  type: "button",
                  disabled: _ctx.uploadLoading || _ctx.loading,
                  class: "btn btn-lg btn-primary",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                }, [
                  _withDirectives(_createElementVNode("span", null, [
                    _hoisted_25,
                    _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                  ], 512), [
                    [_vShow, _ctx.loading]
                  ]),
                  _withDirectives(_createElementVNode("span", null, [
                    _createElementVNode("span", _hoisted_26, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.t("common.submit")), 1)
                  ], 512), [
                    [_vShow, !_ctx.loading]
                  ])
                ], 8, _hoisted_24)
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ], 512),
    _createVNode(_component_FsLightbox, {
      toggler: _ctx.options.toggler,
      sources: _ctx.options.sources,
      slide: _ctx.options.sourcesSlide
    }, null, 8, ["toggler", "sources", "slide"])
  ], 64))
}